import React, { useState } from "react";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import AppUtils from "@src/utils/appUtils";

const FormTextArea = ({
  name,
  label,
  info,
  id,
  error,
  required = false,
  disabled = false,
  readOnly = false,
  placeholder,
  rows = 4,
  className = "",
  textColor,
  validationMode,
  onChange,
  fValue,
}) => {
  const {
    register,
    trigger,
    formState: { errors },
  } = useFormContext();

  const { ref, onChange: rhfOnChange, ...registerProps } = register(name);
  const handleChange = async (event) => {
    rhfOnChange(event);
    if (onChange) await onChange(event);
    if (validationMode === "onChange") await trigger(name);
  };

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={id || name}
          className={`block text-sm font-bold text-${textColor || "gray-700"} mb-2`}
        >
          {label}
          {required && <span>{" * "}</span>}
        </label>
      )}
      {info && (
        <label
          className="block tracking-wide text-gray-400 text-xs text-left mb-2"
          htmlFor={id || name}
        >
          {info}
        </label>
      )}
      <textarea
        {...registerProps}
        ref={ref}
        id={id || name}
        name={name}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        rows={rows}
        onChange={validationMode === "onChange" ? handleChange : onChange}
        value={fValue}
        className={`text-sm appearance-none focus:outline-none block w-full placeholder-gray-400 border rounded-lg py-3 px-4 leading-tight resize-none ${
          error
            ? "border-error focus:border-error"
            : "border-gray-200 focus:border-primary-500"
        } ${!error && !disabled ? "hover:border-gray-400" : ""} ${
          disabled ? "bg-primary-100 text-gray-400" : "bg-white text-gray-700"
        } ${className}`}
      />
      {(error || errors[name]?.message) && (
        <p className="mt-1 text-xs text-error">
          {error || errors[name]?.message}
        </p>
      )}
    </div>
  );
};

FormTextArea.displayName = "FormTextArea";

export const formTextAreaControls = {
  name: {
    propType: PropTypes.string.isRequired,
    description: "Textarea name attribute",
    controlType: "text",
    defaultValue: "textarea-name",
  },
  rows: {
    propType: PropTypes.number,
    description: "Number of visible rows",
    controlType: "number",
    defaultValue: 4,
  },
};

FormTextArea.propTypes = AppUtils.getPropTypeFromControls(formTextAreaControls);

export default FormTextArea;
